export enum CardholderPresent {
  Present = '0',
  NotPresentUnspecified = '1',
  MailOrder = '2',
  TelephoneOrder = '3',
  RecurringTransaction = '4',
  ECommerce = '5',
  InstallmentTransaction = '6',
  Unknown = '9'
}

export enum CardPresent {
  NotPresent = '0',
  Present = '1',
  Unknown = '9'
}

export enum CardDataInputMethod {
  InformationNotProvided = '0',
  ManualNoTerminal = '1',
  MagneticStripeRead = '2',
  BarCode = '3',
  OCR = '4',
  ChipDip = '5',
  KeyEntered = '6',
  EMVContactless = '7',
  ECommerce = 'V',
  ECommerceWithEMVCryptogram = 'C',
  ContactlessMagStripe = 'E',
  AccountDataOnFile = 'F',
  KeyEnteredByAcquirer = 'G',
  MICRReader = 'M',
  QRCode = 'Q'
}

export enum AuthenticationMethod {
  NotAuthenticated = '0',
  PIN = '1',
  ElectronicSignatureAnalysis = '2',
  Biometrics = '3',
  Biographic = '4',
  ManualSignatureVerification = '5',
  OtherManualVerification = '6',
  Other = '7',
  Unknown = '8',
  PasscodePassword = '9',
  Pattern = 'A',
  PossessionOfHardwareDevice = 'B',
  PossessionOfHardwareDeviceWithVerification = 'C',
  PossessionOfSoftwareApplication = 'D',
  PossessionOfSoftwareApplicationWithVerification = 'E',
  Secure3DS = 'S'
}

export enum AuthenticationEntity {
  NotAuthenticated = '0',
  ChipCard = '1',
  CardAcceptanceDevice = '2',
  AuthorisingAgent = '3',
  Merchant = '4',
  Other = '5',
  CardholderDevice = '6',
  WalletProvider = '7',
  Unknown = '8'
}

export enum ChipFallbackIndicator {
  NA = '0',
  PreviousNotFallback = '1',
  PreviousFallback = '2'
}

export enum FraudIndicator {
  NoProblem = '0',
  MerchantSuspicious = '1',
  MerchantVerifiedID = '2'
}

export enum SecurityProtocol {
  None = '0',
  ChannelEncryption = '1',
  NotApplicable = 'N'
}

export enum ThreeDSecureAuthMethod {
  Unknown = 'x',
  Secure102Prior = '0',
  ChallengeStaticPasscode = '1',
  ChallengeOTPviaSMS = '2',
  ChallengeOTPviaKeyFob = '3',
  ChallengeOTPviaApp = '4',
  ChallengeOTPviaOtherMethod = '5',
  ChallengeKBAMethod = '6',
  ChallengeOOBBiometric = '7',
  ChallengeOOBAppLogin = '8',
  ChallengeOOBAnyOtherMethod = '9',
  ChallengeAnyOtherMethod = 'A',
  UnrecognizedMethod = 'B',
  PushConfirmation = 'C',
  FrictionlessRBA = 'D',
  AttemptsServerResponding = 'E',
  FrictionlessFlow = 'F',
  DelegatedAuthentication = 'L',
  ChallengeUnknownMethod = 'y',
  IDCXService = 'v',
  AAVRefresh = 'z'
}

export enum ExemptFromSCA {
  NotExempt = '0',
  ExemptMCC = '1',
  ContactlessLowValue = '2',
  ECommerceLowValue = '3',
  RecurringTransaction = '4',
  Credit = '5',
  MailOrder = '6',
  AcquirerExempt = '7',
  NotTransactionUnderPSD2 = '8',
  Reserved = '9',
  AcquirerTransactionRiskAnalysis = 'A',
  SecureCorporatePayment = 'C',
  SCADelegation = 'D',
  MerchantInitiatedTransaction = 'M',
  AuthenticationOutage = 'O',
  RecurringPayment = 'R',
  TrustedMerchant = 'T',
  LowValuePayment = 'V'
}

export enum SCAAssessmentResult {
  NotMet = '0',
  Met = '1',
  MetTwoOfThreeTests = '2',
  MetBothOneAndTwo = '3',
  DelegatedToToken = 'D',
  NotApplicable = 'N'
}

export enum SCATestResult {
  NotPerformed = 'N',
  Failed = '0',
  Passed = '1'
}

export enum DeviceType {
  Card = 'C',
  Mobile = 'M'
}

export enum InitiatedBy {
  Cardholder = 'C',
  Merchant = 'M',
  Unknown = 'U'
}

export enum MerchantTransactionType {
  CredentialOnFile = '1',
  StandingOrder = '2',
  Subscription = '3',
  Installment = '4',
  PartialShipment = '5',
  RelatedCharge = '6',
  NoShowCharge = '7',
  Resubmission = '8',
  Unknown = 'U'
}

export enum OriginalTransactionIndicator {
  LookupAttempted = 'L',
  NotApplicable = 'X'
}

export enum OriginalTransactionStatus {
  Unknown = 'U'
}

export enum ExtendedAuthorizationIndicator {
  NoExtensionRequested = '0',
  ExtensionRequested = '1'
}

export interface GPSPosData {
  cardholderPresent: CardholderPresent;
  cardPresent: CardPresent;
  cardDataInputMethod: CardDataInputMethod;
  cardholderAuthMethod1: AuthenticationMethod;
  cardholderAuthMethod2: AuthenticationMethod;
  cardholderAuthMethod3: AuthenticationMethod;
  cardholderAuthMethod4: AuthenticationMethod;
  cardholderAuthEntity1: AuthenticationEntity;
  cardholderAuthEntity2: AuthenticationEntity;
  cardholderAuthEntity3: AuthenticationEntity;
  cardholderAuthEntity4: AuthenticationEntity;
  chipFallbackIndicator: ChipFallbackIndicator;
  fraudIndicator: FraudIndicator;
  securityProtocol: SecurityProtocol;
  threeDSecureAuthMethod: ThreeDSecureAuthMethod;
  instantFundingNetwork: number;
  instantFundingGPS: number;
  exemptFromSCA: ExemptFromSCA;
  scaAssessmentResult: SCAAssessmentResult;
  scaTestKnowledge: SCATestResult;
  scaTestPossession: SCATestResult;
  scaTestBiometric: SCATestResult;
  threddExemptSCAIndicator: ExemptFromSCA;
  cardDeviceType: DeviceType;
  acquirerExemptSCAIndicator: ExemptFromSCA;
  authAmountCurrencyComparison: string;
  merchantCardholderInitiatedIndicator: InitiatedBy;
  merchantInitiatedTransactionTypeIndicator: MerchantTransactionType;
  originalTransactionSCAExemptIndicator: OriginalTransactionIndicator;
  originalTransactionSCAAssessmentResult: OriginalTransactionIndicator;
  originalTransactionStatusValue: OriginalTransactionStatus;
  extendedAuthorizationIndicator: ExtendedAuthorizationIndicator;
}

export function parseGPSPosData(data: string): GPSPosData | null {
  if (data == null || data.length < 18) {
    console.error("Data is null or string is too short.");
    return null;
  }

  return {
    cardholderPresent: data.substring(0, 1) as CardholderPresent,
    cardPresent: data.substring(1, 2) as CardPresent,
    cardDataInputMethod: data.substring(2, 3) as CardDataInputMethod,
    cardholderAuthMethod1: data.substring(3, 4) as AuthenticationMethod,
    cardholderAuthMethod2: data.substring(4, 5) as AuthenticationMethod,
    cardholderAuthMethod3: data.substring(5, 6) as AuthenticationMethod,
    cardholderAuthMethod4: data.substring(6, 7) as AuthenticationMethod,
    cardholderAuthEntity1: data.substring(7, 8) as AuthenticationEntity,
    cardholderAuthEntity2: data.substring(8, 9) as AuthenticationEntity,
    cardholderAuthEntity3: data.substring(9, 10) as AuthenticationEntity,
    cardholderAuthEntity4: data.substring(10, 11) as AuthenticationEntity,
    chipFallbackIndicator: data.substring(11, 12) as ChipFallbackIndicator,
    fraudIndicator: data.substring(12, 13) as FraudIndicator,
    securityProtocol: data.substring(13, 14) as SecurityProtocol,
    threeDSecureAuthMethod: data.substring(14, 15) as ThreeDSecureAuthMethod,
    instantFundingNetwork: parseInt(data.substring(15, 16), 10),
    instantFundingGPS: parseInt(data.substring(16, 17), 10),
    exemptFromSCA: data.substring(17, 18) as ExemptFromSCA,
    scaAssessmentResult: data.length > 18 ? data.substring(18, 19) as SCAAssessmentResult : SCAAssessmentResult.NotApplicable,
    scaTestKnowledge: data.length > 19 ? data.substring(19, 20) as SCATestResult : SCATestResult.NotPerformed,
    scaTestPossession: data.length > 20 ? data.substring(20, 21) as SCATestResult : SCATestResult.NotPerformed,
    scaTestBiometric: data.length > 21 ? data.substring(21, 22) as SCATestResult : SCATestResult.NotPerformed,
    threddExemptSCAIndicator: data.length > 22 ? data.substring(22, 23) as ExemptFromSCA : ExemptFromSCA.NotExempt,
    cardDeviceType: data.length > 23 ? data.substring(23, 24) as DeviceType : DeviceType.Card,
    acquirerExemptSCAIndicator: data.length > 24 ? data.substring(24, 25) as ExemptFromSCA : ExemptFromSCA.NotExempt,
    authAmountCurrencyComparison: data.length > 25 ? data.substring(25, 26) : '',
    merchantCardholderInitiatedIndicator: data.length > 26 ? data.substring(26, 27) as InitiatedBy : InitiatedBy.Unknown,
    merchantInitiatedTransactionTypeIndicator: data.length > 27 ? data.substring(27, 28) as MerchantTransactionType : MerchantTransactionType.Unknown,
    originalTransactionSCAExemptIndicator: data.length > 28 ? data.substring(28, 29) as OriginalTransactionIndicator : OriginalTransactionIndicator.NotApplicable,
    originalTransactionSCAAssessmentResult: data.length > 29 ? data.substring(29, 30) as OriginalTransactionIndicator : OriginalTransactionIndicator.NotApplicable,
    originalTransactionStatusValue: data.length > 30 ? data.substring(30, 31) as OriginalTransactionStatus : OriginalTransactionStatus.Unknown,
    extendedAuthorizationIndicator: data.length > 31 ? data.substring(31, 32) as ExtendedAuthorizationIndicator : ExtendedAuthorizationIndicator.NoExtensionRequested
  };
}
